export default __webpack_public_path__ + "static/Express-6fda8197f2723d63ac25a39a372ab911.svg";